import { useContext } from 'react';
import { Button, Modal, ModalCloseButton, ModalDescription, ModalFooter, ModalHeader, ModalTitle, ModalProps, SwitchThemeContext } from '@tryhackme/thm-ui-components';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { ThemeColorMode } from '../enums';
import { StyledDeleteWarningBoxText, StyledDeleteWarningIcon, StyledInfoBox, StyledLabel, StyledWarningBoxIcon } from './delete-modal.styles';
import { DeleteModalProps } from './delete-modal.types';
export const DeleteModal = ({
  modalTitleText,
  modalBodyText,
  actionButtonText = 'Yes',
  onOpenChange,
  activeIndex,
  handleDeleteAction,
  showDeleteWarningBox = false,
  deleteWarningBoxText,
  ...otherModalProps
}: ModalProps & DeleteModalProps) => {
  const {
    theme
  } = useContext(SwitchThemeContext);
  const isDarkMode = theme === ThemeColorMode.DARK;
  const handleAction = () => {
    onOpenChange?.(false);
    handleDeleteAction(activeIndex);
  };
  return <Modal {...otherModalProps} onOpenChange={open => {
    onOpenChange?.(open);
  }} isSmall data-sentry-element="Modal" data-sentry-component="DeleteModal" data-sentry-source-file="delete-modal.tsx">
      <ModalHeader isSmall data-sentry-element="ModalHeader" data-sentry-source-file="delete-modal.tsx">
        <StyledDeleteWarningIcon icon={faCircleExclamation} data-sentry-element="StyledDeleteWarningIcon" data-sentry-source-file="delete-modal.tsx" />
        <ModalTitle data-sentry-element="ModalTitle" data-sentry-source-file="delete-modal.tsx">{modalTitleText}</ModalTitle>
      </ModalHeader>

      <ModalDescription data-sentry-element="ModalDescription" data-sentry-source-file="delete-modal.tsx">
        {typeof modalBodyText === 'string' ? <StyledLabel>{modalBodyText}</StyledLabel> : modalBodyText}
      </ModalDescription>

      {showDeleteWarningBox && <StyledInfoBox isDark={isDarkMode}>
          <StyledWarningBoxIcon icon={faCircleExclamation} />
          <StyledDeleteWarningBoxText>{deleteWarningBoxText}</StyledDeleteWarningBoxText>
        </StyledInfoBox>}

      <ModalFooter isSmall data-sentry-element="ModalFooter" data-sentry-source-file="delete-modal.tsx">
        <ModalCloseButton text="Cancel" data-sentry-element="ModalCloseButton" data-sentry-source-file="delete-modal.tsx" />
        <Button variant="solid" color="error" onClick={handleAction} data-sentry-element="Button" data-sentry-source-file="delete-modal.tsx">
          {actionButtonText}
        </Button>
      </ModalFooter>
    </Modal>;
};